module.exports = {
      id: "icon-share-usage",
      viewBox: "0 0 25.6 25.6",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#icon-share",
      toString: function () {
        return this.url;
      }
    }